<template>
    <div class="auth-wrapper auth-v2">
        <b-row class="auth-inner m-0">
            <div class="w-100 d-flex flex-column justify-content-between">
                <div class="px-2">
                    <div class="d-flex flex-column justify-content-center align-items-center mb-2 mt-2 px-2"
                        style="font-size: 15px; font-weight: 500;">
                        <div class="add-economic-record-title1"> Fecha</div>
                    </div>
                    <div class="add-economic-record-body">
                        <b-row class="justfy-center mt-3">
                            <v-date-picker color="yellow" class="none-border" :border="false"/>
                        </b-row>
                    </div>

                </div>
                <ControlMenu />
            </div>
        </b-row>
    </div>
</template>

<script>
import { BRow, BCol, BLink, BImg, BForm, BButton, BFormSelect, BFormInput, BFormCheckbox, BFormTextarea, } from 'bootstrap-vue'
import ControlMenu from '@/components/ControlMenu.vue'
import {VDatePicker} from 'v-calendar'
export default {
    components: {
        BRow,
        BCol,
        BLink,
        BImg,
        BForm,
        BButton,
        BFormSelect,
        BFormInput,
        ControlMenu,
        BFormCheckbox,
        BFormTextarea,
        VDatePicker
    },
    data() {
        return {
            status: '',
            selected: '',
            options: ['a', 'b', 'c']
        }
    },

}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
